import gql from 'graphql-tag';

export const LISTING_HEAD_FRAGMENT = gql`
    fragment LISTING_HEAD_FRAGMENT on ListingData {
        analyticsTaxonomy {
            location
            regionName
        }
        metaTitle
        metaDescription
        listingUris {
            detail
        }
        propertyImage {
            filename
        }
    }
`;
